var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchGradient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.177 30.0835L24.7507 20.6677C28.0808 15.4704 27.4788 8.46737 22.9371 3.93778C20.4071 1.39605 17.0237 0 13.4346 0C9.84542 0 6.46963 1.39605 3.93207 3.93778C-1.31069 9.17299 -1.31069 17.6935 3.93207 22.9287C6.46963 25.4628 9.84542 26.8589 13.4346 26.8589C16.0331 26.8589 18.5097 26.1153 20.6434 24.7572L30.062 34.173C30.5955 34.7041 31.3042 35 32.0509 35C32.8054 35 33.514 34.7041 34.0398 34.1806L34.1618 34.0592C35.2591 32.9666 35.2591 31.1836 34.1618 30.0835H34.177ZM13.4346 24.5827C10.455 24.5827 7.65839 23.4219 5.54757 21.3202C1.19639 16.9727 1.19639 9.89378 5.54757 5.54628C7.65077 3.43703 10.455 2.27618 13.4346 2.27618C16.4141 2.27618 19.2184 3.43703 21.3216 5.54628C25.6499 9.87102 25.6728 16.8816 21.3978 21.2443L21.2378 21.4036C19.1422 23.4598 16.376 24.5903 13.4346 24.5903V24.5827ZM32.5615 32.4431L32.4396 32.5645C32.3024 32.7011 32.1424 32.7238 32.0662 32.7238C31.9824 32.7238 31.83 32.7011 31.6928 32.5721L22.4951 23.3763L22.8609 23.0121C22.8609 23.0121 22.9218 22.959 22.9523 22.9287C22.9828 22.8983 23.0057 22.868 23.0285 22.8376L23.3638 22.4962L32.5615 31.6844C32.7749 31.8968 32.7673 32.2382 32.5615 32.4431Z",
    fill: "url(#paint0_linear_142_588)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_142_588",
    x1: 4.02351,
    y1: 22.8983,
    x2: 31.8553,
    y2: 14.4474,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EB9923"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F59C60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5D630"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGradient);
export default __webpack_public_path__ + "static/media/search-gradient.97cba23848cd61e733c2e8d587daab21.svg";
export { ForwardRef as ReactComponent };